import { V3Record } from "data/helpers/V3Record.js";
import moment from "moment";

export const Experience = V3Record(
  "experience",
  {
    clubId: null,
    active: null,
    name: null,
    startsOn: null,
    endsOn: null,
    location: null,
    description: null,
    logo: null,
    cover: null,
    expireAfterDays: null,
    referenceId: null,
    requireName: null,
    requireEmail: null,
    requirePhone: null,
    requireReferenceId: null,
    requireZipCode: null,
    showRoutes: null,
    viewConfig: null,
    includeFacebook: null,
    includeTwitter: null,
    includeInstagram: null,
    updatedAt: null,
    unlimited: null,
  },
  { fileAttrs: ["logo", "cover"], readOnly: ["updatedAt"] }
);

Experience.formatDate = (experience) => {
  const start = experience.startsOn;
  const end = experience.endsOn;
  const formattedStart = start && moment(start).format("ddd. MMMM DD");
  const formattedEnd = end && moment(end).format("ddd. MMMM DD");
  return formattedEnd ? formattedStart + " \u2014 " + formattedEnd : formattedStart;
};
